import { DeleteClaimEntity } from "../../domain/entities/delete-claim.entity";

export class DeleteClaimModel extends DeleteClaimEntity {
    override toJson(): Map<string, any> {
        let json: Map<string, any> = new Map();
        json.set('id', this.id);
        return json;
    }

}